<div class="container" *ngIf="loadingHome == true">
  <div class="wrapper">
    <div
      class="mb-20"
      style="display: flex; justify-content: space-between; max-width: 100%"
    >
      <div class="mb-20" style="max-width: 680px">
        <ion-skeleton-text
          animated
          style="
            width: 60%;
            height: 25px;
            border-radius: 12px;
            margin-bottom: 23px;
          "
        ></ion-skeleton-text>
        <ion-skeleton-text
          animated
          style="
            width: 90%;
            height: 96px;
            border-radius: 12px;
            margin-bottom: 40px;
          "
        ></ion-skeleton-text>

        <ion-skeleton-text
          animated
          style="
            width: 50%;
            height: 24px;
            border-radius: 12px;
            margin-bottom: 3.5px;
          "
        ></ion-skeleton-text>
        <ion-skeleton-text
          animated
          style="
            width: 90%;
            height: 96px;
            border-radius: 12px;
            margin-bottom: 48px;
          "
        ></ion-skeleton-text>

        <ion-skeleton-text
          animated
          style="
            width: 65%;
            height: 24px;
            border-radius: 12px;
            margin-bottom: 3.5px;
          "
        ></ion-skeleton-text>
        <ion-skeleton-text
          animated
          style="
            width: 80%;
            height: 96px;
            border-radius: 12px;
            margin-bottom: 24px;
          "
        ></ion-skeleton-text>

        <ion-item lines="none" style="--min-height: 20px">
          <ion-skeleton-text
            animated
            style="
              width: 134px;
              height: 20px;
              border-radius: 12px;
              margin-bottom: 3.5px;
              margin-right: 8px;
            "
          ></ion-skeleton-text>
          <ion-skeleton-text
            animated
            style="
              width: 134px;
              height: 20px;
              border-radius: 12px;
              margin-bottom: 3.5px;
            "
          ></ion-skeleton-text>
        </ion-item>
        <ion-item lines="none" style="--min-height: 20px">
          <ion-skeleton-text
            animated
            style="
              width: 134px;
              height: 20px;
              border-radius: 12px;
              margin-bottom: 3.5px;
              margin-right: 8px;
            "
          ></ion-skeleton-text>
          <ion-skeleton-text
            animated
            style="
              width: 134px;
              height: 20px;
              border-radius: 12px;
              margin-bottom: 3.5px;
            "
          ></ion-skeleton-text>
        </ion-item>
        <ion-item lines="none" style="--min-height: 20px">
          <ion-skeleton-text
            animated
            style="
              width: 134px;
              height: 20px;
              border-radius: 12px;
              margin-bottom: 3.5px;
              margin-right: 8px;
            "
          ></ion-skeleton-text>
          <ion-skeleton-text
            animated
            style="
              width: 134px;
              height: 20px;
              border-radius: 12px;
              margin-bottom: 3.5px;
            "
          ></ion-skeleton-text>
        </ion-item>

        <ion-skeleton-text
          animated
          style="
            width: 320px;
            height: 40px;
            border-radius: 12px;
            margin-top: 25px;
            justify-self: center;
          "
        ></ion-skeleton-text>
      </div>
    </div>
  </div>
</div>

<div class="container" *ngIf="loadingHome == false && !servsError">
  <div class="wrapper">
    <div class="mb-20" style="display: flex; justify-content: space-between">
      <div class="mb-20 content-info-pagos">
        <div
          id="infopago"
          class="title-section-info-pago title"
          (insideViewport)="onElementView($event, 'infopago')"
        >
          Información de pago de pensión
        </div>

        <div class="item-text">
          <ion-text class="div-text mb-40">
            Revisa las fechas, montos y formas de pago de tu última pensión.
            También puedes descargar el comprobante o enviarlo a tu correo.
          </ion-text>
          <app-mensaje-importante
            *ngIf="pagoPension.InformacionPago.mensajeCliente"
            [titulo]="'Importante'"
            [mensaje]="pagoPension.InformacionPago.mensajeCliente"
          ></app-mensaje-importante>
          <h3 class="sub-title">Este fue tu último pago</h3>
          <div class="div-personal-data">
            <div class="div-data">
              <ion-text class="descripcion">Fecha de pago:</ion-text>
              <ion-text class="value">
                {{ pagoPension.InformacionPago.fechaPago }}
              </ion-text>
            </div>
            <div class="div-data">
              <ion-text class="descripcion">Monto de pensión: </ion-text>
              <ion-text class="value" aria-hidden="true">
                ${{
                  pagoPension.InformacionPago.montoPension
                    | number: "1.0-0":"es"
                }}
              </ion-text>
            </div>
            <span class="visually-hidden">
              {{
                pagoPension.InformacionPago.montoPension | number: "1.0-0":"en"
              }}
              pesos</span
            >
            <div class="div-data">
              <ion-text class="descripcion">Líquido a pagar:</ion-text>
              <ion-text class="value" aria-hidden="true">
                ${{
                  pagoPension.InformacionPago.liquidoPagar
                    | number: "1.0-0":"es"
                }}
              </ion-text>
            </div>
            <span class="visually-hidden">
              {{
                pagoPension.InformacionPago.liquidoPagar | number: "1.0-0":"en"
              }}
              pesos</span
            >
            <div class="div-data">
              <ion-text class="descripcion">Forma de pago:</ion-text>
              <ion-text class="value">
                {{ pagoPension.InformacionPago.formaPago | titlecase }}
              </ion-text>
            </div>
            <div
              class="div-data"
              *ngIf="showString(pagoPension.InformacionPago.banco)"
            >
              <ion-text class="descripcion">Banco:</ion-text>
              <ion-text class="value">
                {{ pagoPension.InformacionPago.banco | titlecase }}
              </ion-text>
            </div>
            <div
              class="div-data"
              *ngIf="showString(pagoPension.InformacionPago.numCuenta)"
            >
              <ion-text class="descripcion">Número de cuenta:</ion-text>
              <ion-text class="value">
                {{ pagoPension.InformacionPago.numCuenta }}
              </ion-text>
            </div>
            <div class="div-data">
                <ion-text class="descripcion">Próx. fecha de pago:</ion-text>
                <ion-text class="value">
                  {{ pagoPension.InformacionPago.fechaProximoPago }}
                </ion-text>
              </div>
          </div>
          <ion-text class="div-text" style="margin-top:36px; margin-bottom: 0px">
            Para ver las fechas de los próximos pagos puedes revisarlo en
            <a
              href="https://www.afpcapital.cl/pensiones/calendario-pago"
              target="_blank"
              >Calendario de próximos pagos</a
            >
          </ion-text>
          <p class="link-cambio-pago">
            Si necesitas cambiar tu cuenta bancaria puedes hacerlo en
            <button type="button" routerLink="" class="link" (click)="irCambioViaPago()" (keydown.enter)="irCambioViaPago()">Cambio de vía de pago.</button>
          </p>
        </div>

        <div class="descarga-comprobante">
          <h3 class="sub-title ion-padding-top mb8" id="comprobantepago">
            Comprobante pago de pensión
          </h3>
          <p class="mb24">
            Selecciona un período para tu comprobante, envíalo a tu correo
            registrado o descárgalo.
          </p>

          <app-dropdown-new-design
            [floatingLabel]="'Elige un período'"
            [alignEnd]="false"
            [options]="dateRange"
            class="mb16"
            [tipoDropdown]="'period'"
            [selectedValue]="dateRange[0].value"
            (insideViewport)="onElementView($event, 'comprobantepago')"
            (selectedValueChange)="onDateRangeChange($event)"
          ></app-dropdown-new-design>

          <p *ngIf="emailOfuscado !== ''" class="mb40">
            Enviaremos el comprobante al correo <b>{{ emailOfuscado }}</b
            >, si necesitas actualizarlo puedes hacerlo en
            <a class="link" (click)="goToYourData()" routerLink=""
              >Tus datos.</a
            >
          </p>

          <p *ngIf="emailOfuscado === ''" class="mb40">
            Aún no registras un correo para recibir tus comprobantes, por favor
            agrega uno en
            <a class="link" (click)="goToYourData()" routerLink=""
              >Tus datos.</a
            >
          </p>

          <button
            type="button"
            style="margin-top: 0"
            class="control-btn button mb24"
            [ngClass]="{
              'primary-button': dateRangeSelected > 0,
              'disabled-button': dateRangeSelected == 0
            }"
            *ngIf="emailOfuscado !== ''"
            (click)="enviarEmail()"
            [disabled]="dateRangeSelected == 0 || runSendEmail == true"
          >
            Enviar al correo
            <ion-spinner
              name="crescent"
              slot="end"
              *ngIf="runSendEmail"
              color="light"
            ></ion-spinner>
          </button>

          <button
            type="button"
            class="control-btn button"
            (click)="downloadPDF()"
            [ngClass]="{
              'secondary-button': dateRangeSelected > 0,
              'disabled-button': dateRangeSelected == 0
            }"
            [disabled]="dateRangeSelected == 0 || runDownload == true"
          >
            <ion-text class="btn-text" style="font-weight: 450"
              >Descargar comprobante</ion-text
            >
            <img *ngIf="!runDownload" alt="|_|" [src]="imgDownloadButton()" />
            <ion-spinner
              name="crescent"
              slot="end"
              *ngIf="runDownload"
              color="primary"
            ></ion-spinner>
          </button>
        </div>

        <ion-item class="help-section" lines="none">
          <ion-label>
            Para más información
            <p>
              Llámanos al
              <a href="tel:6006600900" class="text-links">600 6600 900</a>,
              escríbenos al WhatsApp
              <a
                href="https://api.whatsapp.com/send?phone=56936391222"
                target="_blank"
                >+569 3639 1222</a
              >, dirígete a nuestras sucursales, o agenda una
              <a href="/video-atencion">Video Atención.</a>
            </p>
          </ion-label>
        </ion-item>

        <div class="container-modal">
          <ng-container *ngFor="let item of messageList; let i = index">
            <app-confirm-modal
              [image]="item.image"
              [type]="item.type"
              [title]="item.title"
              [description]="item.description"
              (closeModal)="close(i)"
            ></app-confirm-modal>
          </ng-container>
        </div>
      </div>
      <div class="title-section-info-pago nav-div">
        <p class="nav-subtitle">Revisa</p>

        <div class="nav-item" [ngClass]="{ 'nav-item-active': showInfoPago }">
          <p>
            <a
              class="nav-link"
              href="/pensions/informacion-pago-pension/home#infopago"
            >
              Información de pago de pensión
            </a>
          </p>
        </div>
        <div
          class="nav-item mb-20"
          [ngClass]="{ 'nav-item-active': showComprobantePago }"
        >
          <p>
            <a
              class="nav-link"
              href="/pensions/informacion-pago-pension/home#comprobantepago"
              >Comprobante pago de pensión</a
            >
          </p>
        </div>

        <p class="nav-subtitle">Te puede interesar</p>
        <div class="nav-item">
          <p>
            <a
              class="nav-link"
              routerLink=""
              (click)="irCambioViaPago()"
              (keydown.enter)="irCambioViaPago()"
            >Cambio de vía de pago de pensión</a>
          </p>
        </div>
        <div class="nav-item mb-20">
          <p>
            <a
              class="nav-link"
              routerLink=""
              (click)="goToYourBeneficiaries()"
              (keydown.enter)="goToYourBeneficiaries()"
              >Personas Beneficiarias</a>
          </p>
        </div>
      </div>
    </div>
  </div>
</div>

<app-generic-error
  *ngIf="servsError"
  style="height: 100%"
  [ops]="errorOps"
  [retryAttempt]="attempt"
  [enableButtonRetry]="errorOps.enableButtonRetry"
  (retryEvent)="onRetryEvent()"
  (goToEvent)="onGoToEvent()"
>
</app-generic-error>
